'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toggle = exports.TOGGLE_TOGGLE = exports.TOGGLE_HIDE = exports.TOGGLE_SHOW = undefined;

var _atpSugar = require('atp-sugar');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//Action type definitions
var TOGGLE_SHOW = exports.TOGGLE_SHOW = 'basic/toggle/show';
var TOGGLE_HIDE = exports.TOGGLE_HIDE = 'basic/toggle/hide';
var TOGGLE_TOGGLE = exports.TOGGLE_TOGGLE = 'basic/toggle/toggle';

//Action creators and selectors
var toggle = exports.toggle = {
    show: function show(name) {
        return { type: TOGGLE_SHOW, name: name };
    },
    hide: function hide(name) {
        return { type: TOGGLE_HIDE, name: name };
    },
    toggle: function toggle(name) {
        var defaultState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        return { type: TOGGLE_TOGGLE, name: name, defaultState: defaultState };
    },
    isVisible: function isVisible(getState, name) {
        var defaultState = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        return _isVisible(getState().basic.toggle, name, defaultState);
    }
};

var _isVisible = function _isVisible(state, name) {
    var defaultState = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    return typeof state[name] !== 'undefined' ? state[name] : defaultState;
};

//Reducer

exports.default = function () {
    var _o$switch;

    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];
    return (0, _atpSugar.o)(action.type).switch((_o$switch = {}, _defineProperty(_o$switch, TOGGLE_SHOW, function () {
        return (0, _atpSugar.o)(state).merge(_defineProperty({}, action.name, true)).raw;
    }), _defineProperty(_o$switch, TOGGLE_HIDE, function () {
        return (0, _atpSugar.o)(state).merge(_defineProperty({}, action.name, false)).raw;
    }), _defineProperty(_o$switch, TOGGLE_TOGGLE, function () {
        return (0, _atpSugar.o)(state).merge(_defineProperty({}, action.name, !_isVisible(state, action.name, action.defaultState))).raw;
    }), _defineProperty(_o$switch, 'default', function _default() {
        return state;
    }), _o$switch));
};